import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function AnimatedCounter({
  from,
  to,
  duration = 2,
  suffix = ''
}: {
  from: number;
  to: number;
  duration?: number;
  suffix?: string;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  const [count, setCount] = useState(from);
  useEffect(() => {
    if (isInView) {
      let startTime: number;
      let animationFrame: number;
      const animate = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
        // Easing function (easeOutExpo)
        const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        setCount(Math.floor(easeProgress * (to - from) + from));
        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        }
      };
      animationFrame = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [isInView, from, to, duration]);
  return <span ref={ref} data-id="element-200">
      {count.toLocaleString('pt-BR')}
      {suffix}
    </span>;
}
export function StatsBar() {
  const stats = [{
    value: 2000,
    suffix: '+',
    label: 'Empreendedoras'
  }, {
    value: 100,
    suffix: '+',
    label: 'Páginas de Conteúdo'
  }, {
    value: 4.9,
    suffix: '/5',
    label: 'Avaliação Média',
    isFloat: true
  }, {
    value: 7,
    suffix: ' dias',
    label: 'Garantia Total'
  }];
  return <section className="bg-brand-brown py-12 relative z-20" data-id="element-201">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-202">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10" data-id="element-203">
          {stats.map((stat, index) => <div key={index} className={`flex flex-col items-center text-center ${index % 2 === 0 ? 'border-none md:border-solid' : ''} ${index === 0 ? 'border-none' : ''}`} data-id="element-204">
              <div className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-gold mb-2" data-id="element-205">
                {stat.isFloat ? <span data-id="element-206">
                    {stat.value}
                    {stat.suffix}
                  </span> : <AnimatedCounter from={0} to={stat.value} suffix={stat.suffix} data-id="element-207" />}
              </div>
              <div className="text-brand-cream/80 text-sm md:text-base font-medium uppercase tracking-wider" data-id="element-208">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}